import React from 'react';
import getContent from '../lib/dictionaryFetcher';
import { QUIZ_CONSTANTS } from '../lib/constants';
import PropTypes from 'prop-types';
import PopOverContent from './PopOverContent';

class PopOver extends React.Component {
  constructor() {
    super();
    this.state = {
      feedbackTextCount: 0,
      feedbackTextVal: ''
    };
    this.feedbackRef = React.createRef();
  }

  componentDidMount = () =>
    document.addEventListener('click', this.outsideClickClosePopover, false);

  componentWillUnmount = () =>
    document.removeEventListener('click', this.outsideClickClosePopover, false);

  outsideClickClosePopover = event => {
    const { closePopover } = this.props;
    if (!this.feedbackRef.current.contains(event.target)) {
      closePopover({ type: 'outside' });
    }
  };

  textareaCount = ev => {
    const { undoNoTextError } = this.props;
    undoNoTextError();
    let len = ev.target.value.length;
    if (len >= QUIZ_CONSTANTS.feedback.maxCount) {
      this.setState({
        feedbackTextCount: QUIZ_CONSTANTS.feedback.maxCount,
        feedbackTextVal: ev.target.value.substring(
          0,
          QUIZ_CONSTANTS.feedback.maxCount
        )
      });
    } else {
      this.setState({
        feedbackTextVal: ev.target.value,
        feedbackTextCount: len
      });
    }
  };

  render() {
    const {
        type,
        closePopover,
        submitPopOver,
        feedbackNoTextError
      } = this.props,
      { feedbackTextCount, feedbackTextVal } = this.state;
    return (
      <div
        className={`feedback-popover-${type}`}
        id={`feedback-popover-${type}`}
        ref={this.feedbackRef}
      >
        <h2 className="feedback-popover-title">
          {getContent('quiz', 'feedback.popupTitle')}
        </h2>
        <button
          className="feedback-quiz-close add-focus-visible"
          aria-label={getContent('quiz', 'feedback.close')}
          onClick={closePopover}
        >
          <span
            className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close feedback-quiz-close-icon"
            style={{ fontSize: '13px' }}
          />
        </button>
        <div className="feedback-popover-content">
          <PopOverContent
            feedbackTextCount={feedbackTextCount}
            feedbackTextVal={feedbackTextVal}
            closePopover={closePopover}
            submitPopOver={submitPopOver}
            feedbackNoTextError={feedbackNoTextError}
            textareaCount={this.textareaCount}
            labelledBy={`feedback-popover-${type}`}
          />
        </div>
      </div>
    );
  }
}

PopOver.propTypes = {
  type: PropTypes.string,
  closePopover: PropTypes.func,
  submitPopOver: PropTypes.func,
  feedbackNoTextError: PropTypes.string,
  undoNoTextError: PropTypes.func
};

export default PopOver;
